// extracted by mini-css-extract-plugin
export default {"group":"vp_hFwj2","noMargin":"vp_MukKZ","radio":"vp_sFsX0","symbol":"vp_SNUii","dot":"vp_cpMUe","label":"vp_UpXVk","selected":"vp_abh5I"};